module.exports = __webpack_public_path__ + "img/taib1.3bc6ca6c.png";